import * as React from 'react';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useQuery, useLazyQuery } from 'react-apollo';
import { Helmet } from 'react-helmet';

import { GlobalStyles } from './styles/global';
import { Header } from './components/layout/Header';
import { Sidebar } from './components/layout/Sidebar';
import { Content } from './components/layout/Content';
import { Footer } from './components/layout/Footer';
import { Input } from './components/ui/Input';
import { Textarea } from './components/ui/Textarea';
import { SwitchButton } from './components/ui/Switch';

import { OFFICES_QUERY, OFFICE_QUERY } from './__graphql__/queries';
import { url } from 'inspector';

export const App: React.FC = () => {
  const [showHelp, setShowHelp] = useState(false);
  const [officeSelectOpen, openOfficeSelect] = useState(false);
  const [selectedOffice, setSelectedOffice]: any = useState({});
  const [brokerSelectOpen, openBrokerSelect] = useState(false);
  const [selectedBroker, setSelectedBroker]: any = useState({});
  const [officeSelected, setOffice] = useState('');
  const [officeList, setOfficeList] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [name, setName] = useState('');
  const [path, setPath] = useState('');
  const [title, setTitle] = useState('');
  const [phone, setPhone] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [instagram, setInstagram] = useState('');
  const [facebook, setFacebook] = useState('');
  const [linkedin, setLinkedin] = useState('');
  const [custom, setCustom] = useState('');
  const [showLink, setShowLink] = useState(false);
  const [showSale, setShowSale] = useState(false);
  const [showValuation, setShowValuation] = useState(false);

  const { data: officesData } = useQuery(OFFICES_QUERY, {
    variables: {
      input: { pagination: { page: 1, limit: 200 } },
    },
  });
  const [office, { data: officeData }] = useLazyQuery(OFFICE_QUERY, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (
      officesData &&
      officesData.getOffices &&
      officesData.getOffices &&
      officesData.getOffices.list.length
    ) {
      setOfficeList(officesData.getOffices.list);
    }
  }, [officesData]);

  useEffect(() => {
    if (
      officeData &&
      officeData.getOffice &&
      officeData.getOffice &&
      officeData.getOffice.name
    ) {
      setBrokerList(officeData.getOffice.brokers.list);
    }
  }, [officeData]);

  useEffect(() => {
    if (selectedOffice) {
      setSelectedBroker({});
      setName('');
      setPath('');
      setTitle('');
      setPhone('');
      setAddress1('');
      setAddress2('');
      setInstagram('');
      setFacebook('');
      setLinkedin('');
      setCustom('');
      setShowSale(false);
      setShowValuation(false);
      setShowLink(false);
      office({
        variables: {
          input: { id: parseInt(selectedOffice.id) },
        },
      });
    }
  }, [selectedOffice]);

  useEffect(() => {
    if (officeSelectOpen) {
      openBrokerSelect(false);
    }
  }, [officeSelectOpen]);

  const urltagFilter = (urltag) => {
    if (urltag === 'parkveien') {
      return 'park';
    }
    return urltag;
  };

  return (
    <AppWrapper>
      <GlobalStyles />
      <Helmet>
        <title>PrivatMegleren Signatur</title>
      </Helmet>
      <Header showHelp={showHelp} onTabClick={setShowHelp} />
      <Sidebar>
        <Input
          placeholder="Kontor"
          value={officeSelected}
          type="select"
          listName="office"
          list={officeList}
          onChange={(e) => {
            setOffice(e.target.value);
          }}
          onClick={() => {
            openOfficeSelect(!officeSelectOpen);
          }}
          onSelect={(item) => {
            setOffice(item.name);
            setSelectedOffice(item);
          }}
          open={officeSelectOpen}
        />
        {selectedOffice && selectedOffice.name ? (
          <>
            <Input
              placeholder="Navn"
              value={name}
              type="select"
              listName="broker"
              list={
                officeData &&
                officeData.getOffice &&
                officeData.getOffice.brokers &&
                officeData.getOffice.brokers.list
              }
              onChange={(e) => {
                setName(e.target.value);
              }}
              onClick={() => {
                openBrokerSelect(!brokerSelectOpen);
              }}
              onSelect={(item) => {
                setSelectedBroker(item);
                setName(item.name);
                setPath(item.path);
                setTitle(item.title);
                setPhone(item.cellphone);
              }}
              open={brokerSelectOpen}
            />
            <Input
              placeholder="Tittel"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onDelete={() => setTitle('')}
              type="text"
            />
            <Input
              placeholder="Telefon"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onDelete={() => setPhone('')}
              type="text"
            />
            <Input
              placeholder="Adresse 1"
              value={address1}
              onChange={(e) => setAddress1(e.target.value)}
              onDelete={() => setAddress1('')}
              type="text"
            />
            <Input
              placeholder="Adresse 2"
              value={address2}
              onChange={(e) => setAddress2(e.target.value)}
              onDelete={() => setAddress2('')}
              type="text"
            />
            <Input
              placeholder="Instagram-link (husk https://)"
              value={instagram}
              onChange={(e) => setInstagram(e.target.value)}
              onDelete={() => setInstagram('')}
              type="text"
            />
            <Input
              placeholder="Facebook-link (husk https://)"
              value={facebook}
              onChange={(e) => setFacebook(e.target.value)}
              onDelete={() => setFacebook('')}
              type="text"
            />
            <Input
              placeholder="LinkedIn-link (husk https://)"
              value={linkedin}
              onChange={(e) => setLinkedin(e.target.value)}
              onDelete={() => setLinkedin('')}
              type="text"
            />
            <Textarea
              placeholder="Egendefinert innhold"
              value={custom}
              onChange={(e) => setCustom(e.target.value)}
              onDelete={() => setCustom('')}
            />
            {/*<SidebarSection>
              <span className="text">Vis link til Mitt Bolikjøp</span>
              <span className="switch">
                <SwitchButton
                  active={showLink}
                  toggle={() => setShowLink(!showLink)}
                />
              </span>
            </SidebarSection>*/}
            <SidebarSection>
              <span className="text">Vis link til "Be om verdivurdering"</span>
              <span className="switch">
                <SwitchButton
                  active={showValuation}
                  toggle={() => setShowValuation(!showValuation)}
                />
              </span>
            </SidebarSection>
            <SidebarSection>
              <span className="text">Vis link til "Selge boligen"</span>
              <span className="switch">
                <SwitchButton
                  active={showSale}
                  toggle={() => setShowSale(!showSale)}
                />
              </span>
            </SidebarSection>
          </>
        ) : null}
      </Sidebar>
      <Content
        showHelp={showHelp}
        signature={{
          name: name,
          officeName: encodeURIComponent(selectedOffice && selectedOffice.name),
          title: title,
          phone: phone,
          path: path,
          address1: address1,
          address2: address2,
          instagram: instagram,
          facebook: facebook,
          linkedin: linkedin,
          custom: custom,
          urltag: selectedOffice && urltagFilter(selectedOffice.urltag),
          showLink: showLink,
          showValuation,
          showSale,
        }}
      />
      <Footer />
    </AppWrapper>
  );
};

const AppWrapper = styled.div`
  width: 100%;
`;

const SidebarSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  .text {
    font-size: 16px;
    color: #6f7373;
  }
  .switch {
  }
`;
